import { AppState } from '../../state/app.state';

export const getPage = (state: AppState) => state.home.selectedPage;
